import { Skeleton } from '@chakra-ui/react';

export const SkeletonNftItem = () => {
  return (
    <Skeleton
      borderRadius="16px"
      w="full"
      h="170px"
      boxShadow="0 4px 16px rgba(0, 0, 0, 0.16)"
    />
  );
};
